<template>
  <modal
    :show.sync="showAndClose"
    bodyClasses="pt-0"
    size="lg"
    @close="closeModal"
  >
    <template slot="header" class="pb-0">
      <h6 class="subtitle" id="modal-title-default">
        Tags
      </h6>
    </template>
    <div class="row forms mt-4">
      <div class="col-xl-6 col-md-12 col-sm-12 col-12 box-flex">
        <div class="card">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <base-input
                v-model.trim="$v.tag.name.$model"
                inputClasses="text-capitalize"
                label="Name"
                @input="changeName"
                placeholder="Name"
                id="name"
                name="name"
                tab-index="15"
                :error="
                  !$v.tag.name.minLength || $v.tag.name.$error
                    ? `Minimum ${$v.tag.name.$params.minLength.min} letters.`
                    : ''
                "
              />
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
              <label class="title-label">Description</label>
              <el-input
                v-model.trim="$v.tag.description.$model"
                placeholder="Description"
                id="Description"
                name="Description"
                maxlength="160"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                show-word-limit
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 box-flex">
        <div class="card">
          <div class="table-tags">
            <b-table
              hover
              :items="tags"
              :fields="fields"
              sort-by.sync="name"
              sort-asc.sync="true"
              selectable
              ref="selectableTable"
              sort-icon-left
              responsive
              show-empty
              empty-filtered-text="There are no records matching your request"
              empty-text="There are no records to show"
            >
              <template #cell(product)="data">
                <span class="title hide-data" @click="editTag(data._id)">
                  {{ data.item.name }}
                </span>
              </template>

              <template #cell(actions)="data">
                <el-tooltip content="Delete" placement="bottom">
                  <span
                    class="icon-action text-danger ml-2"
                    @click="deleteTagById(data.item._id)"
                  >
                    <i class="flaticon-delete"></i>
                  </span>
                </el-tooltip>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <div class="modal-footer col-12">
        <base-button
          type="outline-neutral mb-0"
          class="min-button"
          @click="closeModal()"
        >
          <i class="flaticon-cancel"></i> Close
        </base-button>

        <base-button
          type="primary"
          class="min-button ml-auto mb-0"
          @click="saveTag()"
        >
          <i class="flaticon-floppy-disk"></i> Add
        </base-button>
      </div>
    </div>
  </modal>
</template>

<script>
import lodash from "lodash";
import { mapGetters, mapActions } from "vuex";
import WSelect from "@/components/Select";
import { Select } from "element-ui";
import { TagsAPI } from "../../../../../core/api";
import {
  required,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);

Select.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "add-tags",
  components: {
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    }
  },
  data() {
    return {
      tag: {
        name: "",
        slug: "",
        description: ""
      },
      loading: false,
      options: [],
      showAndClose: false,
      fields: [
        {
          key: "name",
          label: "Tags",
          sortable: false,
          class: "text-left",
          thStyle: { minWidth: "120px" }
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ]
    };
  },
  async created() {
    this.getTags();
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showAndClose = current;
      },
      deep: true
    }
  },
  methods: {
    async saveTag() {
      if (!this.$v.tag.$invalid) {
        let tag = lodash.cloneDeep(this.tag);
        await this.createTag(tag);
        this.clearData();
        await this.getTags();
      } else {
        this.$v.tag.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createTag(tag) {
      try {
        let { data } = await TagsAPI.createTags(tag, this.sesion.token);
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Tag has been Saved",
            icon: "flaticon-check-mark"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the Tag, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Tag, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    clearData() {
      this.$v.tag.$reset();
      this.tag.name = "";
      this.tag.slug = "";
      this.tag.description = "";
    },
    closeModal(tag = null) {
      this.clearData();
      this.$emit("closeTagsModal", false);
    },
    async deleteTagById(tagId) {
      try {
        let { data } = await TagsAPI.deleteTagById(tagId, this.sesion.token);
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Tag has been deleted",
            icon: "flaticon-check-mark"
          });
          this.getTags();
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "This tag can't be deleted. Is associated with one or more products",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    changeName(name) {
      this.tag.slug = this.createSlug(name);
    },
    createSlug(name = "") {
      return name
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");
    },
    editTag() {},
    ...mapActions(["getTags"])
  },
  computed: {
    ...mapGetters(["sesion", "tags"])
  },
  validations: {
    tag: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(20),
        ValName
      },
      slug: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(20)
      },
      description: {
        minLength: minLength(0),
        maxLength: maxLength(160)
      }
    }
  }
};
</script>
